import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quanxian-xuanze",
  "use": "icon-quanxian-xuanze-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-quanxian-xuanze\"><path d=\"M511.8 64.3c-247.1 0-447.4 200.3-447.4 447.4s200.3 447.4 447.4 447.4 447.4-200.3 447.4-447.4S758.9 64.3 511.8 64.3z m0 642.5c-108.1 0-195.7-87.6-195.7-195.7s87.6-195.7 195.7-195.7S707.5 403 707.5 511.1s-87.6 195.7-195.7 195.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol